export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.template': 'Template',
  'menu.reimbursements': 'Reimbursements',
  'menu.reimbursements.dashboard': 'Dashboard',
  'menu.reimbursements.invoices': 'Invoices',
  'menu.reimbursements.invoices.my': 'My Invoices',
  'menu.reimbursements.invoices.all': 'All Invoices',
  'menu.reimbursements.claims': 'Claims',
  'menu.reimbursements.claims.my': 'My Claims',
  'menu.reimbursements.claims.all': 'All Claims',
  'menu.reimbursements.approval': 'Approvals',
  'menu.reimbursements.approvalDetail': 'Approval Detail',
  'menu.reimbursements.claimEdit': 'Claim Form',
  'menu.reimbursements.analytics': 'Analytics',
  'menu.reimbursements.myAnalytics': 'My Analytics',
  'menu.reimbursements.managementCockpit': 'Management Cockpit',
  'menu.reimbursements.financeAnalytics': 'Finance Analytics',
  'menu.reimbursements.specialAnalytics': 'Finance Analytics',
  'menu.reimbursements.analytics.reimbursements.myAnalytics': 'My Analytics',
  'menu.reimbursements.analytics.reimbursements.financeAnalytics':
    'Finance Analytics',
  'menu.reimbursements.analytics.reimbursements.managementCockpit':
    'Management Cockpit',
  'menu.settings': 'Settings',
  'menu.settings.reimbursement': 'Reimbursement Settings',
  'menu.settings.anomalyRules': 'Anomaly Rules',
  'menu.settings.buyers': 'Buyer Settings',
  'menu.settings.expenseCategories': 'Expense Categories',
  'menu.settings.sceneTemplates': 'Scene Templates',
  'menu.settings.personalQuotaConfigs': 'Personal Quotas',
  'menu.settings.expenseStandardPolicies': 'Expense Standard Policies',
  'menu.settings.permissions': 'Permission Management',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
